if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        super.connectedCallback();

        if (this.navigationReady) return;
        this.navigationReady = true;

        this.querySelectorAll('[data-product-modal-nav]').forEach((button) => {
          button.addEventListener('pointerup', (event) => event.stopPropagation());
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.navigateMedia(button.dataset.productModalNav === 'next' ? 1 : -1);
          });
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.setActiveMedia(this.openedBy.getAttribute('data-media-id'));
      }

      setActiveMedia(mediaId) {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        requestAnimationFrame(() => {
          activeMedia.scrollIntoView({
            block: 'center',
            inline: 'center',
            behavior: 'auto',
          });
        });
      }

      navigateMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        const activeIndex = mediaItems.findIndex((item) => item.classList.contains('active'));

        if (mediaItems.length < 2 || activeIndex === -1) return;

        const nextIndex = (activeIndex + direction + mediaItems.length) % mediaItems.length;
        this.setActiveMedia(mediaItems[nextIndex].dataset.mediaId);
      }
    }
  );
}
